import Axios from 'axios';

export const OrderlineAxios = Axios.create({
  baseURL: import.meta.env.DEV
    ? ''
    : import.meta.env.CHECKOUT_WEB_ORDERLINE_API_URL,
  headers: {
    accept: 'application/json',
    'content-type': 'application/json',
  },
});

OrderlineAxios.interceptors.request.use(config => {
  config.headers['X-Client'] = 'checkout-web';
  config.headers['X-Source'] = 'checkout-web';
  return config;
});
